import axios from "configs/axios";

const all = (options = { params: {}}) => axios.get(`/orders`, options);

export default all